import React from 'react';
import MapSingle from '../../map/MapSingle';
import EventsListing from '../../sections/EventsListing';
import {useCategories, useInfiniteEvents} from '../../../api/hooks';
import Loader from '../Loader';
import Error from '../Error';
import {Translate} from '../../../config/TranslationProvider';
import Contact from '../../sections/Contact';
import ImageHeader from '../head/ImageHeader';
import Title from '../layout/Title';

const HostContent = ({host}) => {
    const {
        data: eventGroups,
        isLoading: eventsLoading,
        error: eventsError,
        fetchMore,
        canFetchMore,
        isFetchingMore
    } = useInfiniteEvents({'end_date_from': 'today', 'hosts': host.id});

    const {data: categories, isLoading: categoriesLoading, error: categoriesError} = useCategories();

    if (eventsLoading || categoriesLoading) {
        return <Loader />;
    }

    if (eventsError || categoriesError) {
        return <Error errors={[eventsError && eventsError, categoriesError && categoriesError]} />;
    }

    return (
        <>
            <ImageHeader host={host} type="hostDetails" />
            <Title>{host.title}</Title>
            <section className="directory_listing_detail_area single_area section-bg section-padding-strict">
                <div className="container">
                    <div className="row">
                        {/* Left Side */}
                        <div className="col-lg-8">

                            {host?.location && <MapSingle location={host.location} title="host_location" />}

                        </div>

                        {/* Right Side */}
                        <div className="col-lg-4">

                            {host && <Contact host={host} />}

                        </div>

                        <div className="col-12">
                            <div className="atbd_content_module">
                                <div className="atbd_content_module__tittle_area">
                                    <div className="atbd_area_title">
                                        <h2 className="h4"><span className="la la-group" />&nbsp;
                                            <Translate value="host_events" />
                                        </h2>
                                    </div>
                                </div>
                                <div className="atbdb_content_module_contents">
                                    <EventsListing
                                        type="grid4"
                                        eventGroups={eventGroups}
                                        fetchMore={fetchMore}
                                        canFetchMore={canFetchMore}
                                        isFetchingMore={isFetchingMore}
                                        categories={categories}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};


export default HostContent;
